import DownloadCircle from "assets/images/icon/download-circle"

export const reportsColumns = () => {
    return [
        {
            headerName: "Name",
            key: "name",
            renderValue: (row) => {
                return <span style={{ color: '#1B75F0' }}>{row?.name}</span>
            }
        },
        {
            headerName: "Description",
            key: "description"
        },
    ]
}

export const authorizationDocsColumns = (onDownload) => {
    return [
        { headerName: "Jurisdiction", key: "jurisdiction" },
        { headerName: "Label", key: "label" },
        { headerName: "Year", key: "year" },
        { headerName: "Filed On", key: "field_on" },
        {
            headerName: "",
            key: "action_field",
            renderValue: (row) => (
                <div style={{ cursor: 'pointer' }} onClick={() => onDownload && onDownload(row.id)}>
                    <DownloadCircle />
                </div>
            )
        },
    ]
}

export const companyDocsColumns = (onDownload) => {
    return [
        { headerName: "Label", key: "label" },
        { headerName: "Year", key: "year" },
        { headerName: "Filed On", key: "field_on" },
        {
            headerName: "",
            key: "action_field",
            renderValue: (row) => (
                <div style={{ cursor: 'pointer' }} onClick={() => onDownload && onDownload(row.id)}>
                    <DownloadCircle />
                </div>
            )
        },
    ]
}

export const employeeDocsColumns = (onDownload) => {
    return [
        { headerName: "Employee", key: "employee" },
        { headerName: "Label", key: "label" },
        { headerName: "Category", key: "category" },
        { headerName: "Year", key: "year" },
        { headerName: "Filed On", key: "field_on" },
        {
            headerName: "",
            key: "action_field",
            renderValue: (row) => (
                <div style={{ cursor: 'pointer' }} onClick={() => onDownload && onDownload(row.id)}>
                    <DownloadCircle />
                </div>
            )
        },
    ]
}

export const contractorDocsColumns = (onDownload) => {
    return [
        { headerName: "Contractor", key: "employee" },
        { headerName: "Label", key: "label" },
        { headerName: "Category", key: "category" },
        { headerName: "Year", key: "year" },
        { headerName: "Filed On", key: "field_on" },
        {
            headerName: "",
            key: "action_field",
            renderValue: (row) => (
                <div style={{ cursor: 'pointer' }} onClick={() => onDownload && onDownload(row.id)}>
                    <DownloadCircle />
                </div>
            )
        },
    ]
}
